import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';

import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule } from 'primeng/keyfilter';
import { HttpClientModule } from '@angular/common/http';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RegistrationComponent } from './registration/registration.component';
import { RegistrationConsentComponent } from './registration-consent/registration-consent.component';

@NgModule({
    declarations: [
        AppComponent,
        RegistrationComponent,
        RegistrationConsentComponent
    ],
    imports: [
        CardModule,
        FormsModule,
        ToastModule,
        RippleModule,
        ButtonModule,
        DialogModule,
        MessageModule,
        BrowserModule,
        DropdownModule,
        CheckboxModule,
        InputTextModule,
        KeyFilterModule,
        HttpClientModule,
        RadioButtonModule,
        InputTextareaModule,
        ReactiveFormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }
